import React, {lazy, Suspense} from 'react';
import {BrowserRouter,Routes,Route} from 'react-router-dom';
import ReactDOM from "react-dom";

import './css/app.less';
import {Spin} from "antd";

const Test = lazy(() => import("./js/pages/Browse"));
const SearchPage = lazy(() => import("./js/pages/SearchPage"))
const Statistics= lazy(() => import("./js/pages/Statistics"))
const Home= lazy(() => import("./js/pages/Home"))
const CREBrowse=lazy(() => import("./js/pages/CREBrowse"))
const SCREBrowse=lazy(() => import("./js/pages/SCREBrowse"))
const CREInfo=lazy(() => import("./js/pages/CREInfo"))
const SCREInfo=lazy(() => import("./js/pages/SCREInfo"))
const Contact=lazy(() => import("./js/pages/Contact"))
const Help=lazy(() => import("./js/pages/Help"))
const Download=lazy(() => import("./js/pages/Download"))


const naviData={
    CREDetails:0,
}
localStorage.setItem('naviData',JSON.stringify(naviData));

// ------------------------------------
// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(<Main/>);

ReactDOM.render(
    <Suspense fallback={<div
        className={'wp100 h1000 flex-c-n-c-c'}
    >
        <Spin
            size="large"
        />
    </div>} >
        <BrowserRouter>
            <Routes>
                <Route
                    path={'*'}
                    element={<Home/>}
                />
                <Route
                    path={'/explorer'}
                    element={<Test/>}
                />
                <Route
                    path={'/home'}
                    element={<Home/>}
                />
                <Route
                    path={'/CREBrowse'}
                    element={<CREBrowse/>}
                />
                <Route
                    path={'/CREInfo'}
                    element={<CREInfo/>}
                />
                <Route
                    path={'/SCREInfo'}
                    element={<SCREInfo/>}
                />
                <Route
                    path={'/search'}
                    element={<SearchPage/>}
                />
                <Route
                    path={'/contact'}
                    element={<Contact/>}
                />
                <Route
                    path={'/statistics'}
                    element={<Statistics/>}
                />
                <Route
                    path={'/help'}
                    element={<Help/>}
                />
                <Route
                    path={'/Download'}
                    element={<Download/>}
                />
                <Route
                    path={'/SCREBrowse'}
                    element={<SCREBrowse/>}
                />
            </Routes>
        </BrowserRouter>
    </Suspense>
    ,
    document.getElementById('root')
)